import { render } from "./QuestionsAccordions.vue?vue&type=template&id=5752dc71&scoped=true"
import script from "./QuestionsAccordions.vue?vue&type=script&lang=js"
export * from "./QuestionsAccordions.vue?vue&type=script&lang=js"

import "./QuestionsAccordions.vue?vue&type=style&index=0&id=5752dc71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5752dc71"]])

export default __exports__